<template>
  <div class="media-left">
    <div :class="['grabber', showGrabber ? 'grabber-left' : '']"></div>
    <div class="tweet-index">
      <div :class="['top-line', showLineUp ? '' : 'no-line']"></div>
      <div class="media-left-body">
        <slot></slot>
      </div>
      <div  :class="['bottom-line', showLineDown ? '' : 'no-line']"></div>
    </div>
    <div class="grabber"></div>
  </div>
</template>

<script>
export default {
  name: "TweetMediaLeft",
  props: {
    showGrabber: {
      type: Boolean,
      default: false,
    },
    showLineUp: {
      type: Boolean,
      default: false,
    },
    showLineDown: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>

.media-left {
  color: #7a7a7a;
  cursor: grab;
  margin-right: 0;
  display: flex;
  flex-direction: row;

  .grabber {
    width: 5px;
    border-right: dotted 2px transparent;
  }

  &:hover .grabber-left {
    border-color: hsl(0, 0%, 86%) !important;
  }

  .tweet-index {
    width: 48px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .top-line {
      background-color: hsl(0, 0%, 86%);
      width: 1px;
      height: 0.75rem;
      flex-grow: 0;
    }

    .bottom-line {
      background-color: hsl(0, 0%, 86%);
      width: 1px;
      flex-grow: 1;
    }

    .no-line {
      width: 0 !important;
    }
  }
}
</style>
